import { ChangeDetectorRef, Directive, OnDestroy, OnInit } from '@angular/core';
import { NgInject } from '@df/ng/ng-inject';
import { Subscription } from 'rxjs';
import { AppBusyStateService, IAppBusyState } from '@df/ui/display/busy-state/app-busy-state.service';

@Directive()
export abstract class AppBusyStateComponentDef implements OnInit, OnDestroy {
    appBusyState?: IAppBusyState;

    protected appBusyStateSubscription?: Subscription;

    @NgInject(AppBusyStateService)
    protected appBusyStateService!: AppBusyStateService;

    constructor(protected _ref: ChangeDetectorRef) {
        this._ref.detach();
    }

    ngOnInit() {
        this.appBusyStateService.subscribe((busyState: IAppBusyState | undefined) => {
            if (this.appBusyState !== busyState) {
                this.appBusyState = busyState;
                this._ref.detectChanges();
            }
        });
    }

    ngOnDestroy() {
        if (this.appBusyStateSubscription) {
            this.appBusyStateSubscription.unsubscribe();
        }
    }
}
